import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import * as mobx from 'mobx'
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import AttachMoney from '@material-ui/icons/AttachMoney';
import Help from '@material-ui/icons/Help';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';

import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';

import MainView from "./MainView";
import logo from '../../assets/img/sonicleadgen.png';
import SideMenu from './SideMenu'
import AddCreditDialog from './AddCreditDialog'
//import { mailFolderListItems, otherMailFolderListItems } from './tileData';

const drawerWidth = 240;

function isEmpty(obj) {

  if (obj){
    return Object.keys(obj).length === 0 ;
  }
  return true
}


const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100%',
  },
  flex: {
    flex: 1,
  },
  logo: {
    height: 50,
    marginLeft: theme.spacing.unit,
  },
  logoutButton:{
    marginRight: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
  },
  appFrame: {
    height: '100%',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    width: '100%',
  },
  appBar: {
    position: 'absolute',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  'appBarShift-left': {
    marginLeft: drawerWidth,
  },
  'appBarShift-right': {
    marginRight: drawerWidth,
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 20,
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    position: 'relative',
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    //padding: theme.spacing.unit * 3,
    /*transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),*/
  },
  'content-left': {
    marginLeft: -drawerWidth,
  },
  'content-right': {
    marginRight: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  'contentShift-left': {
    marginLeft: 0,
  },
  'contentShift-right': {
    marginRight: 0,
  },
});

@inject("commonStore")
@inject("authStore")
@observer
class LeadHome extends Component {
  state = {
    open: false,
    anchor: 'right',
    showTabs: true,
    showCreditDialog: false
  };
  handleLogout = async () => {
    console.log('handleLogout')
    await this.props.authStore.logout();
    console.log('should reload')
    window.localStorage.clear()
    window.location.reload();
  }
  makeCampaignNames = () => {
     const { campaigns } = this.props.commonStore
     console.log('makeCampaignNames')
   //  console.log(campaigns)
    // let items = mobx.toJS(campaigns)

    return campaigns.map(campaign => {
        console.log(campaign)
        const { campaignName, campaignID } = campaign
        return (
            <MenuItem key={campaignID} value={campaignID}>{campaignName}</MenuItem>
        )
    })

}
  openDialog = (type) => {
    //check type for future
    this.setState({showCreditDialog: true})
  }
  handleCloseForm = (values) => {
    const { syncUser } = this.props.authStore
    syncUser()
    this.setState({ showCreditDialog: false })
  }
  handleTabToggle = (open) => {
    this.setState({ showTabs: open });
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  handleChangeAnchor = event => {
    this.setState({
      anchor: event.target.value,
    });
  };

  render() {
    const { classes, theme, commonStore } = this.props;
    const { anchor, open, showTabs, showCreditDialog } = this.state;
    const { agent } = commonStore
    console.log(showTabs)
    /*const drawer = (
      <Drawer
        variant="persistent"
        anchor={anchor}
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
      <SideMenu handleDrawerClose={this.handleDrawerClose} openDialog={this.openDialog}/>
      </Drawer>
    );

    let before = null;
    let after = null;

    if (anchor === 'left') {
      before = drawer;
    } else {
      after = drawer;
    }*/

    return (
      <div className={classes.root}>
    
        <div className={classes.appFrame}>
          <AppBar color="default"
            className={classNames(classes.appBar,/* {
              [classes.appBarShift]: open,
              [classes[`appBarShift-${anchor}`]]: open,
            }*/)}
          >
            <Toolbar disableGutters={!open}>
            <Typography variant="title" color="inherit" className={classes.flex}>
            <img src={logo} className={classes.logo}/>
            </Typography>

     { /* showTabs ?
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => {this.handleTabToggle(false)}}
            className={classNames(classes.menuButton, open && classes.hide)}
          >
            <KeyboardArrowUp /> 
          </IconButton>
          :<IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => {this.handleTabToggle(true)}}
            className={classNames(classes.menuButton, open && classes.hide)}
          >
          <KeyboardArrowDown />
          </IconButton>
     */}

     


          <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={() => {this.openDialog('addCredit')}}
          className={classNames(classes.menuButton, open && classes.hide)}
        >
        <AttachMoney />
        </IconButton>

          <Typography>
          {`Account Credit: $${(agent.credit / 100).toLocaleString()}`}
          </Typography>


          <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={()=> window.open('https://www.sonicwebdev.com/support', "_blank")}
          className={classNames(classes.menuButton, open && classes.hide)}
        >
        <Help />
        </IconButton>

          <Button className={classes.logoutButton} onClick={this.handleLogout}> Sign Out </Button>

        
     


            </Toolbar>

          </AppBar>

          {/*before*/}
          <main
            className={classNames(classes.content, /*classes[`content-${anchor}`], {
             [classes.contentShift]: open,
              [classes[`contentShift-${anchor}`]]: open,
            }*/)}
          >
            <div className={classes.drawerHeader} />
            <MainView 
              showTabs={true}
            />
          </main>
         {/*after*/}
        </div>
        {showCreditDialog ? <AddCreditDialog open={ showCreditDialog } handleClose={this.handleCloseForm} /> : null }
      </div>
    );
  }
}

LeadHome.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(LeadHome);


// WEBPACK FOOTER //
// ./src/components/Leads/index.js